import { Typography } from '@/components/Typography';
import { GenericLoadingElement } from '../../components/GenericLoadingElement';

export const BookingResultLoading = () => {
  return (
    <div id="jbp-job-screen" className="mx-10 mt-6">
      <div className="flex flex-row justify-start mb-4 items-center h-[50px]">
        <Typography content="We're waiting for your booking to be accepted. Please wait" className="mt-2" />
      </div>
      <div className="mb-6">
        <GenericLoadingElement count={1} height="h-20"></GenericLoadingElement>
      </div>
      <div className="grid grid-cols-3 gap-6">
        <div className="flex flex-col">
          <GenericLoadingElement count={1} height="h-96"></GenericLoadingElement>
        </div>
        <div className="flex flex-col">
          <GenericLoadingElement count={1} height="h-80"></GenericLoadingElement>
        </div>
        <div className="flex flex-col">
          <GenericLoadingElement count={3} height="h-24"></GenericLoadingElement>
        </div>
      </div>
    </div>
  );
};
